import cn from 'classnames';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import IconCheck from '@creditflowresearch/uilib/Icon/IconCheck';
import StepperType from './StepperType';

import styles from './stepper.module.scss';

export interface IProps {
  /**
   * An array of objects representing each step in the stepper.
   */
  steps: {
    url: string | number,
    title: string,
    dataTest: string,
  }[],
  /**
   * The current step in the stepper, identified by its `url`.
   */
  currentStep: string | number,
  /**
   * Optional type of stepper (S, M, L) for styling/sizing purposes.
   */
  stepperType?: StepperType,
  /**
   * Boolean indicating whether the stepper is disabled and cannot be interacted with.
   */
  isDisabled?: boolean,
}

const Stepper = ({ steps, currentStep, isDisabled = false, stepperType = StepperType.L }: IProps) => {
  const headerItems = steps.map((step, index) => {
    const isActive = step.url === currentStep;
    const isCompleted = index < steps.findIndex((el) => el.url === currentStep);

    return (
      <div
        key={ step.url }
        className={ cn(styles.step, {
          [styles.isActive]: isActive,
          [styles.isDisabled]: isDisabled,
          [styles.isCompleted]: isCompleted,
          [styles.typeL]: stepperType === StepperType.L,
          [styles.typeM]: stepperType === StepperType.M,
          [styles.typeS]: stepperType === StepperType.S,
        }) }
        data-test={ step.dataTest }
      >
        <Tooltip
          content={ step.title }
          disabled={ isActive || isDisabled }
          containerClassName={ styles.tooltip }
          className={ styles.stepTooltip }
        >
          <div className={ styles.circle }>
            { isCompleted
              ? <IconCheck />
              : index + 1 }
          </div>
        </Tooltip>
        <span className={ styles.title }>
          { step.title }
        </span>
        <span className={ styles.dash } />
      </div>
    );
  });

  return (
    <div
      className={ styles.header }
    >
      <div className={ styles.menuWrapper } data-test="stepFormWrapper">
        <div
          className={ styles.headerMenu }
        >
          { headerItems }
        </div>
      </div>
    </div>
  );
};

export default Stepper;
